import { useCallback, useEffect, useState } from "react";

export const DISPLAY_LANGUAGE_STORAGE_KEY = "display_language";
export const DEFAULT_DISPLAY_LANGUAGE = "de";
export const DISPLAY_LANGUAGE_CHANGE_EVENT = "display-language-change";

// Fallback for the *call's* source language when room metadata lacks
// `language_config.language_code`. Distinct from DEFAULT_DISPLAY_LANGUAGE
// (which is the admin's UI language) — the two just happen to coincide today.
export const DEFAULT_SOURCE_LANGUAGE = "de";

export function getDisplayLanguage(): string {
  return (
    localStorage.getItem(DISPLAY_LANGUAGE_STORAGE_KEY) ??
    DEFAULT_DISPLAY_LANGUAGE
  );
}

export function useDisplayLanguage(): [string, (lang: string) => void] {
  const [language, setLanguage] = useState<string>(
    () =>
      localStorage.getItem(DISPLAY_LANGUAGE_STORAGE_KEY) ??
      DEFAULT_DISPLAY_LANGUAGE,
  );

  useEffect(() => {
    const handler = (e: Event) => {
      setLanguage((e as CustomEvent<string>).detail);
    };
    globalThis.addEventListener(DISPLAY_LANGUAGE_CHANGE_EVENT, handler);
    return () =>
      globalThis.removeEventListener(DISPLAY_LANGUAGE_CHANGE_EVENT, handler);
  }, []);

  const persistLanguage = useCallback((lang: string) => {
    localStorage.setItem(DISPLAY_LANGUAGE_STORAGE_KEY, lang);
    globalThis.dispatchEvent(
      new CustomEvent(DISPLAY_LANGUAGE_CHANGE_EVENT, { detail: lang }),
    );
    setLanguage(lang);
  }, []);

  return [language, persistLanguage];
}
